import css from 'styled-jsx/css'

import { colors, sizes, common } from '../../theme'


export default css`
main {
  ${common.page}
}

main > section {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

section.header {
  position: relative;
  display: flex;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
}

section.header :global(div:first-child) {
  width: 100%;
  max-width: 120rem;
  padding-left: 0;
  padding-right: 0;
}

section.photos {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
}

section.description :global(div:first-child) {
  width: 100%;
  max-width: 120rem;
}

section.description {
  margin-top: 11rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

section.projects :global(.project-content) {
  max-width: ${sizes.body.tablet.maxWidth};
  width: 100%;
  margin: 0 auto;
  margin-top: 10rem;
}

section.projects :global(.title) {
  position: relative;
}

section.projects :global(.project-title) {
  max-width: ${sizes.media.tablet.maxWidth};
  margin: 6rem auto 2rem auto;
}

section.projects :global(.project-title .container) {
  max-width: 100%;
  padding: 0;
  display: block;
}

section.projects-link {
  width: 100%;
  max-width: 120rem;
  margin: 15rem auto;
}

section.projects-link :global(.link-projects span) {
  font-size: 6rem;
  font-family: 'Taviraj-Light', serif;
  color: ${colors.pureWhite};
  font-weight: 400;
}

section.projects-link :global(.link-projects .icon img) {
  height: 3rem;
  margin-right: 3rem;
  color: ${colors.pureWhite};
}

.separator {
  width: calc(100% - 18rem);
  margin-top: 1rem;
  border-bottom: 2px solid ${colors.pureWhite};
  margin-left: 8rem;
}

.project-navigation {
  position: fixed;
  top: calc(50% - 6rem);
  z-index: 7;
  width: 100%;
  left: 0;
  display: flex;
  justify-content: center;
  pointer-events: none;
}

.project-navigation-inner {
  display: flex;
  width: 100%;

  /* max-width: ${sizes.body.desktop.maxWidth}; */
  justify-content: space-between;
}

.project-navigation :global([class*=project-button]) {
  opacity: 1;
  position: relative;
  pointer-events: all;
  transition: all 300ms ease;
}

.project-navigation :global([class*=project-button]:hover) :global(.icon img) {
  opacity: 0.8;
}

.project-navigation :global([class*=project-button]:active) :global(.icon img) {
  opacity: 0.4;
}

.project-navigation :global([class*=project-button] .case) {
  width: 0;
  height: 0;
  border-style: solid;
}

.project-navigation :global([class*=project-button] .icon) {
  width: 3rem;
  height: 3rem;
  position: absolute;
  top: calc(10rem - 1.5rem);
  pointer-events: none;
}

.project-navigation :global([class*=project-button] .icon img) {
  transition: opacity 150ms ease;
  width: 100%;
  height: 100%;
}

.project-navigation :global(.project-button-previous) {
  left: 0;
}

.project-navigation :global(.project-button-previous .case) {
  border-width: 10rem 0 8rem 8rem;
  border-color: transparent transparent transparent ${colors.governorBayBlue};
}

.project-navigation :global(.project-button-previous .icon) {
  left: 1.8rem;
  transform: scaleX(-1);
}

.project-navigation :global(.project-button-next) {
  right: 0;
}

.project-navigation :global(.project-button-next .case) {
  border-width: 10rem 10rem 8rem 0;
  border-color: transparent ${colors.softPink} transparent transparent;
}

.project-navigation :global(.project-button-next .icon) {
  right: 3rem;
}

@media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
  main {
    min-width: ${sizes.constants.tablet.minWidth};
  }

  section.header :global(div:first-child) {
    padding-left: 2rem;
    padding-right: 2rem;
  }


  section.header :global(.cloud) {
    height: 12rem;
  }

  section.header :global(.cloud img) {
    height: 100%;
  }

  section.description {
    margin-top: 2rem;
    padding: 0 2rem;
  }

  section.projects-link {
    width: auto;
    margin: 4rem 2rem 0 4rem;
  }
  
  section.projects-link :global(.link-projects span) {
    font-size: 3.6rem;
    line-height: 43.2px;
  }
  
  section.projects-link :global(.link-projects .icon img) {
    height: 2.4rem;
    margin-right: 0;
    margin-top: 1rem;
  }

  section.projects :global(.project-title) {
    margin-top: 2rem;
    margin-bottom: 2rem;
    width: 100%;
  }

  .project-navigation.hide :global(.project-button-previous) {
    left: -15rem;
  }

  .project-navigation.hide :global(.project-button-next) {
    right: -15rem;
  }

  section.projects :global(.project-content) {
    margin-top: 5rem;
    padding: 0 2rem;
  }
}

@media screen and (max-width: ${sizes.media.mobile.maxWidth}) {

  .project-navigation [class*=project-button] {
  }

  .project-navigation  :global([class*=project-button] .icon) {
    width: 2rem;
    height: 2rem;
    top: calc(5rem - 1rem);
  }

  .project-navigation :global(.project-button-previous .case) {
    border-width: 5rem 0 4rem 4rem;
  }

  .project-navigation :global(.project-button-previous .icon) {
    left: 0.8rem;
  }

  .project-navigation :global(.project-button-next .case) {
    border-width: 5rem 5rem 4rem 0;
  }

  .project-navigation :global(.project-button-next .icon) {
    right: 1.2rem;
  }

  .separator {
    width: calc(100% - 8rem);
    margin-left: 4rem;
  }
}
`
